import {
  Pilot, PilotApi, PilotMutation, // eslint-disable-line no-unused-vars
} from '@clients/myTrips'
import { AxiosPromise } from 'axios' // eslint-disable-line no-unused-vars
import appendCredentials from '@util/appendCredentials'
import getBasePath from '@util/path'

let basePath = getBasePath() + '/my-trips'

export default class ExtendedPilotApi extends PilotApi {
  getPilots (options?: any): AxiosPromise<Array<Pilot>> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.getPilots(undefined, optionsParam)
  }

  createPilot (pilotCreateRequestBody: PilotMutation, options?: any): AxiosPromise<Pilot> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.createPilot(pilotCreateRequestBody, undefined, optionsParam)
  }

  getPilot (id: number, options?: any): AxiosPromise<Pilot> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.getPilot(id, undefined, optionsParam)
  }

  updatePilot (id: number, pilotUpdateRequestBody: PilotMutation, options?: any): AxiosPromise<Pilot> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.updatePilot(id, pilotUpdateRequestBody, undefined, optionsParam)
  }

  deletePilot (id: number, options?: any): AxiosPromise<void> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.deletePilot(id, undefined, optionsParam)
  }

  getPilotSuggestions (options?: any): AxiosPromise<Array<PilotMutation>> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.getPilotSuggestions(undefined, optionsParam)
  }
}
